"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var GroupedListItem = function GroupedListItem(_ref) {
  var item = _ref.item;
  return (0, _preact.h)("div", {
    className: "list-item",
    "data-value": item.value,
    onClick: item.onClick
  }, item.title);
};

var GroupedList = function GroupedList(_ref2) {
  var items = _ref2.items;
  return (0, _preact.h)("div", {
    className: "list"
  }, items.map(function (item) {
    return (0, _preact.h)("div", null, (0, _preact.h)("div", {
      className: "list-item list-item-group-name"
    }, item.groupName), item.items.map(function (item) {
      return (0, _preact.h)(GroupedListItem, {
        item: item
      });
    }));
  }));
};

var _default = GroupedList;
exports.default = _default;